import {
  createContext,
  type Dispatch,
  type FC,
  type MutableRefObject,
  type PropsWithChildren,
  type SetStateAction,
  useRef,
  useState,
} from 'react';
import useMeasure, { type RectReadOnly } from 'react-use-measure';

interface ClaimAnimationContextType {
  isAnimationStart: boolean;
  setIsAnimationStart: Dispatch<SetStateAction<boolean>>;
  refTapElem: (element: HTMLElement | SVGElement | null) => void;
  tapElemMeasure: RectReadOnly;
  activeNavMeasure: RectReadOnly | null;
  setActiveNavMeasure: Dispatch<SetStateAction<RectReadOnly | null>>;
  isStockAnimationStart: boolean;
  setIsStockAnimationStart: Dispatch<SetStateAction<boolean>>;
  deltaY: MutableRefObject<number>;
}

const ClaimAnimationContext = createContext({} as ClaimAnimationContextType);

const ClaimAnimationProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isAnimationStart, setIsAnimationStart] = useState(false);
  const deltaY = useRef<number>(0);
  const [refTapElem, tapElemMeasure] = useMeasure();
  const [activeNavMeasure, setActiveNavMeasure] = useState<RectReadOnly | null>(
    null,
  );
  const [isStockAnimationStart, setIsStockAnimationStart] = useState(false);

  return (
    <ClaimAnimationContext.Provider
      value={{
        isStockAnimationStart,
        setIsStockAnimationStart,
        isAnimationStart,
        setIsAnimationStart,
        refTapElem,
        tapElemMeasure,
        activeNavMeasure,
        setActiveNavMeasure,
        deltaY,
      }}
    >
      {children}
    </ClaimAnimationContext.Provider>
  );
};

export { ClaimAnimationContext, ClaimAnimationProvider };
